import { CHANGE_STATUS_SOCKET, SET_SOCKET, CHANGE_ID, RECONNECT, DISCONNECT } from "../actions/type";

const initialState = {
  isSocket: false,
  socket: undefined,
  id: undefined,
  isDisconnect: false,
  isReconnect: false,
};

const socketReducers = (state = initialState, action) => {
  switch (action.type) {
    case CHANGE_STATUS_SOCKET: {
      return {
        ...state,
        isSocket: action.payload,
      };
    }

    case SET_SOCKET : {
      return{
        ...state,
        socket: action.payload
      }
    }

    case CHANGE_ID : {
      return{
        ...state,
        id: action.payload
      }
    }

    case DISCONNECT : {
      return{
        ...state,
        isDisconnect: action.payload
      }
    }

    case RECONNECT : {
      return{
        ...state,
        isReconnect: action.payload
      }
    }

    default:
      return state;
  }
};

export default socketReducers;
